module.exports = __webpack_public_path__ + "img/bed-icon-black.453625b0.png";